import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
import { useTranslation } from 'react-i18next';
import AdminPageLayout from '../../../layout/AdminPageLayout';
import backgroundImage from '../../../assets/images/admin-bg.png';
import BgImageContent from '../../../layout/BgImageContent';
import ForgotPasswordForm from '../../../forms/forgotPassword';
const ForgotPasswordPage = () => {
    const { t } = useTranslation();
    return (_jsx(AdminPageLayout, { children: _jsx("div", { className: 'page-content-wrapper forgot-password-page', children: _jsx(BgImageContent, { backgroundColor: "#01978833", imageSrc: backgroundImage, imagePosition: 'bottom', title: t('admin.forgot_password_title'), color: "#000", children: _jsx(ForgotPasswordForm, {}) }) }) }));
};
export default ForgotPasswordPage;
